export default __webpack_public_path__ + "static/media/FamilyTreeDna.c5bda1f5.png";